import axios from 'axios';
import { API_URL } from '../config/api';
import SessionService from './SessionService';

const authHeaders = () => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Authentication token not found');
  return { Authorization: `Bearer ${token}` };
};

export interface WhatsAppTemplateVariableOption {
  index: number;
  title: string;
  example: string;
  /** lead = automática (nome do cliente) · common = preenchida por quem envia. */
  kind: string;
}

/** Modelo aprovado pela Meta que o compositor oferece em "Enviar modelo". */
export interface WhatsAppTemplateOption {
  id: string;
  name: string;
  body?: string | null;
  headerText?: string | null;
  footer?: string | null;
  category?: string | null;
  language: string;
  variables: WhatsAppTemplateVariableOption[];
}

export interface SendWhatsAppTemplateInput {
  sectorId: number;
  contactId: number;
  templateId: string;
  /** Valor de cada variável, pelo número. */
  values: Record<string, string>;
  idempotencyKey: string;
}

export const listWhatsAppTemplates = async (sectorId: number): Promise<WhatsAppTemplateOption[]> => {
  const response = await axios.get(`${API_URL}/whatsapp/templates`, { params: { sectorId }, headers: authHeaders() });
  return response.data?.items ?? [];
};

export const sendWhatsAppTemplate = async (input: SendWhatsAppTemplateInput): Promise<{ messageId: number; duplicate: boolean }> => {
  const response = await axios.post(`${API_URL}/whatsapp/templates/send`, input, { headers: authHeaders() });
  return response.data;
};

/** Texto do erro do servidor (já em português) ou um genérico. */
export const templateSendErrorText = (e: unknown): string =>
  (e as { response?: { data?: { message?: string } } })?.response?.data?.message || 'Não foi possível enviar o modelo agora. Tente de novo.';
